module.exports = __webpack_public_path__ + "files/9e93760ad067141835ce27fa2a2ab93d.svg";